import React from 'react';
import { MeatballMenu, ButtonCallToAction, ButtonTertiary, PromptConfirmationModal } from 'ui';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import * as navigate from 'app/area/shared/navigation';

import { getBackRoute } from '../../common/route';
import { DashboardAdminTranslation } from '../../constants';
import { DashboardItem } from '../types-store';
import { replaceTemplateString } from 'app/infrastructure/platform';

import styles from './dashboard-sticky-header.scss';

export interface DashboardStickyHeaderProps {
  dashboardItem: DashboardItem;
  favouriteId: number;
  name: string;
  fetching: boolean;
  onSave: () => void;
  onDelete: () => void;
  translation: DashboardAdminTranslation;
}

export const DashboardStickyHeader: React.FC<DashboardStickyHeaderProps> = ({
  dashboardItem, favouriteId, name, fetching, onSave, onDelete, translation
}) => {

  const disabled = isDisabled(dashboardItem.disabled);

  const updatingItem = isDefinedIncludingZero(dashboardItem?.id);

  const onCancel = () => {
    navigate.to({ pathname: getBackRoute(dashboardItem.id, favouriteId) });
  };

  return <StickyHeader rightSideContent={<>
    <StickyHeaderButtonContainer>
      <ButtonTertiary
        id="dashboard-form-sticky-header-cancel-button"
        onClick={onCancel}>
        {translation.cancel}
      </ButtonTertiary>
      <ButtonCallToAction
        id="dashboard-form-sticky-header-save-button"
        onClick={onSave}
        disabled={false}>
        {translation.save_dashboard_button}
      </ButtonCallToAction>
    </StickyHeaderButtonContainer>
    {updatingItem && <MeatballMenu id="dashboard-form-sticky-header-meatballmenu">
      <li>
        <PromptConfirmationModal
          title={translation.delete_dashboard_title}
          description={replaceTemplateString(
            translation.delete_confirmation,
            name)}
          continueText={translation.delete_dashboard_button}
          cancelText={translation.cancel}
          onContinue={onDelete}>
          <button type="button" className="dropdown-item" disabled={fetching}>
            {translation.delete_dashboard_button}
          </button>
        </PromptConfirmationModal>
      </li>
    </MeatballMenu>}
  </>} >
    <div className={styles.headerContainer}>
      {updatingItem ? <span className={styles.headerId}>
        #{dashboardItem.id}
      </span> : null}
      <h2 className={styles.headerTitle}>
        {updatingItem
          ? name || null
          : translation.new_dashboard}
      </h2>
      {disabled ? <Tag>{translation.disabled}</Tag> : null}
    </div>
  </StickyHeader>;
};
